<template>
  <div class="wrapper" :class="{column: !small}">
    <span class="icon-triangle-alert-exclamation-warning icon"></span>
    <span v-if="small" class="error-message">
      An error occurred
    </span>
    <span v-else class="error-message">
      An error occurred loading the data. Try to select other filtering parameters or refresh the page
    </span>
  </div>
</template>

<script setup lang="ts">
interface IMcErrorProps {
  small?: boolean
}
withDefaults(defineProps<IMcErrorProps>(),{
  small: false
})
</script>

<style>
:root {
  --mc-error-icon-size: 64px;
  --mc-error-icon-color: var(--colour-icons-danger-subtle);
  --mc-error-text-font-size: var(--font-size-body-large);
  --mc-error-text-line-height: var(--line-height-l);
  --mc-error-text-font-weight: var(--font-weight-body-medium);
  --mc-error-text-color: var(--colour-text-neutral-subtle);
  --mc-error-text-max-width: 320px;
}
</style>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .icon {
    color: var(--mc-error-icon-color);
    font-size: var(--mc-error-icon-size);
  }

  .error-message {
    color: var(--mc-error-text-color);    
    font-size: var(--mc-error-text-font-size);
    font-weight: var(--mc-error-text-font-weight);
    line-height: var(--mc-error-text-line-height);
    max-width: var(--mc-error-text-max-width);
    font-style: normal;
    text-align: center;
  }
  &.column {
    flex-direction: column;
  }
}
</style>
